import { CreateBetGameSettingType, ResReadBetGameSettingListType, UpdateBetGameSetting } from '@/types';
import { Box, Button } from '@mui/material';
import { useState, MouseEvent, useEffect } from 'react';
import { z as zod } from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Loading from '@/component/mui/Backdrop';
import BetGameSettingForm from '@/component/bet/BetGameSettingForm';
import { useLocation } from 'react-router-dom';
import { readBetGameSettingDetail } from '@/api/bet/read';
import { SUCCESS } from '@/lib/common/name-space';
import { toast } from 'react-toastify';
import { updateBetGameSetting } from '@/api/bet/update';
import { compareObjects } from '@/lib/Compare';
const schema = zod.object({
  gameSettingId: zod.string().optional(),
  name: zod.string().min(1, { message: '컨트랙트 주소, 필수 입력' }),
  totAmount: zod.string().optional(),
  type: zod.number().min(1, { message: '사용자 지갑주소, 필수입력' }),
  minTotAmount: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  jackpotAmount: zod.string().optional(),
  jackpotReady: zod.string().optional(),
  betLimitMax: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  betLimitMin: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  jackpotAmountRatio: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  jackpotReadyRatio: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  burnAmountRatio: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  winMultiple: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
  regDt: zod.string().optional(),
  isActive: zod.number().min(1, { message: '사용자 지갑주소, 필수입력' }),
  inviteBetRatio: zod.string().min(1, { message: '피추천인 베팅금액 대비 리워드, 필수입력' }),
  inviteWinRatio: zod.string().min(1, { message: '피추천인 당첨금 대비 리워드, 필수입력' }),
  referralRatio: zod.string().min(1, { message: '레퍼럴 서비스 운용 비율, 필수입력' }),
});

type Values = zod.infer<typeof schema>;
const defaultValues = {
  gameSettingId: '',
  name: '',
  totAmount: '',
  type: -1,
  minTotAmount: '',
  jackpotAmount: '',
  jackpotReady: '',
  betLimitMax: '',
  betLimitMin: '',
  jackpotAmountRatio: '',
  jackpotReadyRatio: '',
  burnAmountRatio: '',
  regDt: '',
  isActive: 0,
  winMultiple: '',
  inviteBetRatio: '',
  inviteWinRatio: '',
  referralRatio: '',
} satisfies Values;

export default function BetGameSettingDetail() {
  const {
    state: { gameSettingId },
  } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState<CreateBetGameSettingType | ResReadBetGameSettingListType>({
    gameSettingId: gameSettingId,
    name: '',
    totAmount: '',
    type: 999,
    minTotAmount: '',
    jackpotAmount: '',
    jackpotReady: '',
    betLimitMax: '',
    betLimitMin: '',
    jackpotAmountRatio: '',
    jackpotReadyRatio: '',
    burnAmountRatio: '',
    regDt: '',
    isActive: 0,
    winMultiple: '',
    inviteBetRatio: '',
    inviteWinRatio: '',
    referralRatio: '',
  });
  const [oldSettings, setOldSettings] = useState(settings);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  useEffect(() => {
    (async () => {
      const re = await readBetGameSettingDetail(gameSettingId);
      if (re.status !== SUCCESS) {
        toast.error(re.message);
        return;
      }
      setSettings(re.data);
      setOldSettings(re.data);
    })();
  }, [gameSettingId]);
  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    const data = compareObjects(settings, oldSettings);
    console.log(data);
    if (!settings || !oldSettings) {
      return;
    }
    const result: UpdateBetGameSetting = {
      gameSettingId: gameSettingId!,
      ...data,
    };
    try {
      await updateBetGameSetting(result as UpdateBetGameSetting);
      toast.success('성공');
    } catch (e) {
      console.log(e);
      toast.error('실패');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        {settings && <BetGameSettingForm settings={settings} setSettings={setSettings} types="update" />}
        <Button variant="contained" onClick={onSubmit}>
          Update
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
